"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    var _a, _b;
    return ({
        formControl: (_a = {},
            _a[theme.breakpoints.only('xs')] = {
                display: 'block',
            },
            _a),
        input: (_b = {
                backgroundColor: '#E4E7EB',
                borderRadius: 4,
                padding: theme.spacing(0, 1)
            },
            _b[theme.breakpoints.up('sm')] = {
                minWidth: 200,
            },
            _b[theme.breakpoints.only('xs')] = {
                width: '100%',
            },
            _b),
    });
});
function DeckFilterInput(_a) {
    var options = _a.options, other = __rest(_a, ["options"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement(Autocomplete_1.default, __assign({ multiple: true, groupBy: function (option) { return option.group; }, getOptionLabel: function (option) {
            return typeof option === 'object' ? option.name : option;
        }, className: classes.root, classes: {}, options: options, renderInput: function (params) {
            return (react_1.default.createElement(TextField_1.default, __assign({}, params, { InputProps: __assign(__assign({}, params.InputProps), { disableUnderline: true, className: classes.input }), className: classes.formControl, placeholder: "Filter", margin: "none" })));
        } }, other)));
}
DeckFilterInput.defaultProps = {};
exports.default = DeckFilterInput;
//# sourceMappingURL=DeckFilterInput.js.map